import React from 'react';
import style from './CountDown.css';
import CircularProgressbar from '../CircularProgressbar/';
import { getTimestamp } from '../../lib/utils';

const padNumber = time => `00${time}`.slice(-2);

function toRemainTimeObj(remainTime) {
  const day = Math.floor(remainTime / 86400);
  const hour = padNumber(Math.floor(remainTime % 86400 / 3600));
  const minute = padNumber(Math.floor(remainTime % 3600 / 60));
  const second = padNumber(Math.floor(remainTime % 60));

  return { day, hour, minute, second };
}

const CountDownView = ({ remainTime }) => {
  const { day, hour, minute, second } = toRemainTimeObj(remainTime);
  const countDownItems = [
    {
      text: day,
      percentage: day / 30 * 100,
      caption: '天',
    },
    {
      text: hour,
      percentage: hour / 24 * 100,
      caption: '小時',
    },
    {
      text: minute,
      percentage: minute / 60 * 100,
      caption: '分',
    },
    {
      text: second,
      percentage: second / 60 * 100,
      caption: '秒',
    },
  ];

  return (<div className={style.CountDown}>
    { countDownItems.map((item, index) =>
    (<CircularProgressbar strokeWidth={2} key={index} {...item} classForPercentage={style.ProgressPadding}/>))}
  </div>);
};

class CountDown extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.forceUpdate(), 100);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  render() {
    const now = getTimestamp();
    const { endTime } = this.props;

    if (now < endTime) {
      return (<CountDownView remainTime={endTime - now} />);
    }

    return (<CountDownView remainTime={0} />);
  }
}

export default CountDown;



// WEBPACK FOOTER //
// ./src/components/CountDown/index.js